module.exports = "<button class=\"btn\" [ngClass]=\"data.class\" (click)=\"submit()\">{{ data.text ? data.text : ('Submit' | translate) }}</button>"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-core/src/app/forms/plugins/button-plugin/button-plugin.component.html
// module id = ./libs/chassis-core/src/app/forms/plugins/button-plugin/button-plugin.component.html
// module chunks = main